import { render, staticRenderFns } from "./under18View.vue?vue&type=template&id=5ef4687e"
import script from "./under18View.vue?vue&type=script&setup=true&lang=js"
export * from "./under18View.vue?vue&type=script&setup=true&lang=js"
import style0 from "./under18View.vue?vue&type=style&index=0&id=5ef4687e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports